const newsItems = document.querySelectorAll('.news__body')

newsItems.forEach((ele) => {
  ele.addEventListener('click', event => {
    ele.classList.toggle('news__body--open')
    ele.classList.toggle('news__body--close')
  })
})
